<script>
import Button from "@core/components/common/Button.vue";
import { BFormGroup, BBadge, BRow, BCol } from 'bootstrap-vue'
import { VueAutosuggest } from 'vue-autosuggest'
import AddSubstanceModal from "@/views/product/components/product-card/AddSubstanceModal.vue";

export default {
    components: {AddSubstanceModal, Button, BFormGroup, VueAutosuggest, BBadge, BRow, BCol},
    props: {
        substances: {
            type: Array,
            default() {
                return [];
            }
        },
        loading: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        allowAddNew: {
            type: Boolean,
            default: false,
        },
        isSelected: {
            default() {
                return () => false;
            }
        },
        inputLabel: {
            default() {
                return 'Search substances'
            }
        }
    },
    data() {
        return {
            suggestions: [],
            maxSuggestions: 50,
        }
    },
    methods: {
        addSubstance() {
            this.$refs.addSubstanceModal.show();
        },
        getSuggestionValue() {
            return '';
        },
        include(s) {
            this.$emit('include', s);
        },
        findSubstance(query) {
            const q = (query || '').trim().toLowerCase();

            if (!q) {
                this.suggestions = [];
                return;
            }

            const filtered = this.substances.filter(item => {
                const title = (item.title || '').toLowerCase();
                const cas = (item.cas || '').toLowerCase();
                const ec = (item.ec || '').toLowerCase();
                return title.includes(q) || cas.includes(q) || ec.includes(q);
            }).slice(0, this.maxSuggestions);

            this.suggestions = [{data: filtered}];
        },
    }
}
</script>

<template>
    <div>
        <AddSubstanceModal
            v-if="allowAddNew && !disabled"
            ref="addSubstanceModal"
            @created="include"
        />
        <b-row>
            <b-col :md="allowAddNew && !disabled ? 10 : 12" :lg="allowAddNew && !disabled ? 9 : 12">
                <b-form-group :label="inputLabel">
                    <vue-autosuggest
                        :suggestions="suggestions"
                        :input-props="{placeholder: $t('Component(Composition):search-placeholder'), class: 'form-control w-100', disabled: disabled || loading}"
                        :get-suggestion-value="getSuggestionValue"
                        @selected="(item) => include(item.item)"
                        @input="findSubstance"
                    >
                        <div slot-scope="{suggestion}">
                            <div>
                                <div class="pb-1">
                                    <strong>{{ suggestion.item.title }}</strong>
                                </div>
                                <div>
                                    <b-badge variant="success" class="mr-1" v-if="isSelected(suggestion.item)">
                                        selected
                                    </b-badge>
                                    <b-badge class="mr-1">CAS: {{ suggestion.item.cas }}</b-badge>
                                    <b-badge>EC: {{ suggestion.item.ec }}</b-badge>
                                </div>
                            </div>
                        </div>
                    </vue-autosuggest>
                </b-form-group>
            </b-col>

            <b-col v-if="allowAddNew && !disabled" md="2" lg="3" class="d-flex align-items-end pb-1">
                <Button :block="true" @click="addSubstance">{{ $t('Component(Button):add-substance') }}</Button>
            </b-col>
        </b-row>
    </div>
</template>

